import { graphql } from "react-relay";

export const fastCrawlLoaderFragments = {
  flowState: graphql`
    fragment FastCrawlLoader_flowState on FlowState {
      id
      flowKey
      current {
        state
        percentComplete
        errorMessage
      }
      pending {
        state
        percentComplete
        errorMessage
      }
    }
  `,
};
